import axios from 'axios';
import qs from 'qs';
import store from '../store/store';
import { silentLoginRequest } from '../services/users/authConfig';
import { setAccessToken as setAccessTokenAction } from '../store/users/actions';

const getConfig = async (queryParams?: any, disableTokenRefresh?: boolean) => {
  const config: {
    headers: any;
    params?: any;
    responseType?: any;
  } = {
    headers: {},
  };

  const { users } = store.getState();

  if (typeof queryParams !== 'undefined') {
    config.params = queryParams;
  }

  axios.interceptors.response.use(
    (successResponse) => successResponse,
    (error) => {
      if (error.response.status === 401) {
        store.dispatch(setAccessTokenAction(null));
        throw error;
      }

      if (error.response.status === 403) {
        throw error;
      }
    }
  );

  if (users.msalAccount === null) {
    return config;
  }

  const msalSilentLoginRequest = silentLoginRequest(users.msalAccount);

  if (
    msalSilentLoginRequest.redirectUri == null ||
    msalSilentLoginRequest.redirectUri === ''
  ) {
    return config;
  }

  if (disableTokenRefresh) {
    config.headers.Authorization = `Bearer ${users.accessToken}`;
  } else {
    try {
      const msalResponse = await users.msalInstance?.acquireTokenSilent(
        msalSilentLoginRequest
      );

      const token = msalResponse?.idToken;

      config.headers.Authorization = `Bearer ${token}`;
      store.dispatch(setAccessTokenAction(token === undefined ? null : token));
    } catch (e) {
      console.log('Token fetch failed');
      return config;
    }
  }

  return config;
};

export default {
  delete: async (url: string): Promise<any> => {
    const result = await axios.delete(url, await getConfig());
    return result.data;
  },
  get: async (
    url: string,
    queryParams?: any,
    disableTokenRefresh?: boolean
  ): Promise<any> => {
    const result = await axios.get(
      url,
      await getConfig(queryParams, disableTokenRefresh)
    );

    return result.data;
  },
  getFile: async (url: string, queryParams?: any): Promise<any> => {
    const config = await getConfig(queryParams);
    config.responseType = 'arraybuffer';

    const aAxios = axios.create({
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' }),
    });

    return aAxios.get(url, config);
  },
  getFileByPost: async (url: string, data: any): Promise<any> => {
    const config = await getConfig(); // queryParams);
    config.responseType = 'arraybuffer';

    const aAxios = axios.create({
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' }),
    });

    return aAxios.post(url, data, config);
  },
  post: async (url: string, data: any): Promise<any> => {
    const result = await axios.post(url, data, await getConfig());
    return result.data;
  },
  postFile: async (url: string, data: any): Promise<any> => {
    const config = await getConfig();
    config.headers['Content-Type'] = 'multipart/form-data';
    const result = await axios.post(url, data, config);
    return result.data;
  },
  put: async (url: string, data: any): Promise<any> => {
    const result = await axios.put(url, data, await getConfig());
    return result.data;
  },
};
